import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { RadioContext } from './radiogroup';

const StyledLabel = styled.label`
  cursor: pointer;
  & > input {
    cursor: inherit;
  }
  display: flex;
  flex: 1;
  gap: 0.5rem;
`;

const Radio = ({ children, value, name, defaultChecked, disabled }) => {
  const group = useContext(RadioContext);
  return (
    <StyledLabel>
      <input
        type="radio"
        value={value}
        name={name}
        defaultChecked={defaultChecked}
        disabled={disabled || group.disabled}
        checked={group.value !== undefined ? value === group.value : undefined}
        onChange={(e) => group.onChange && group.onChange(e.target.value)}
      />
      {children}
    </StyledLabel>
  );
};

export default Radio;
